import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { ACCOUNT_MENU_LIST_ID } from './primaryNavConstants'

function PrimaryNavAccountMenu({
  accountMenuOpen,
  accountMenuAnchor,
  accountMenuHeader,
  accountMenuItems,
  onClose,
  onItemSelect,
}) {
  return (
    <FloatingMenuPopup
      open={accountMenuOpen}
      anchorEl={accountMenuAnchor}
      onClose={onClose}
      header={accountMenuHeader}
      items={accountMenuItems}
      onItemSelect={onItemSelect}
      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
      transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      menuListId={ACCOUNT_MENU_LIST_ID}
      menuListAriaLabel="Account"
    />
  )
}

export default PrimaryNavAccountMenu
